import { render } from "./sellreport.vue?vue&type=template&id=645d7e66"
import script from "./sellreport.vue?vue&type=script&lang=js"
export * from "./sellreport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__